import React from "react";
import Footer from "../components/ui/Footer";
import NavbarHome from "../components/ui/NavbarHome";
import { NoPageIcon } from "../components/ui/Swicons";

function NoPage() {
  return (
    <div>
      <div className="overflow-hidden">
        <span className="font-nunito">
          <NavbarHome />
          <div className="relative 2xl:block xl:block lg:block md:block pt-10 sm:pt-20 pb-10 2xl:h-screen xl:h-screen lg:h-screen md:h-screen md:bg-transparent bg-themeLightColor ">
            <div className="relative">
              <div className="min-h-full max-w-screen-xl mx-auto sm:flex justify-center px-6 flex-col">
                <div className="w-52 mx-auto mt-10 mb-8">
                  <NoPageIcon />
                </div>
                <h1 className="text-center text-3xl font-semibold text-white  mb-4">
                  Page Under Construction...
                </h1>
              </div>
            </div>
          </div>
          <Footer />
        </span>
      </div>
    </div>
  );
}

export default NoPage;
